import styled, { css } from 'styled-components';

const navTitleOffset = '16px';

export const selectedStyle = css`
    border-bottom-color: var(--color-NavigationLink-highlight);
    color: var(--color-NavigationLink-textActive);
`;

export const NavigationLink = styled.a.attrs({ className: 'cds-t-body' })<{ $selected?: boolean }>`
    height: 100%;
    padding: 0 ${navTitleOffset};
    text-align: center;
    display: flex;
    align-items: center;
    text-decoration: none;
    position: relative;
    border: none;
    border-bottom: 2px solid transparent;
    background: none;
    color: var(--color-NavigationLink-text);
    ${({ $selected }) => $selected && selectedStyle};
    :hover {
        ${selectedStyle};
        text-decoration: none;
    }
    > * {
        font-weight: bold;
        display: inline-block;
        vertical-align: middle;
    }
`;
